import {ServerError, ErrorCode} from '../../shared/types';

interface TransformErrorOptions {
    quickLinks?: Record<string, string>;
}

export const transformError = (error: ServerError, options?: TransformErrorOptions) => {
    switch (error.errorCode) {
        case ErrorCode.CONTACT_SUPPORT: {
            const {quickLinks} = options || {};
            const {contactSupport} = quickLinks || {};
            return {
                ...error,
                messageVars: [contactSupport]
            };
        }
        default:
            return error;
    }
};
